const TENBIS_SAFE_ORIGINS = [
  'https://www.10bis.co.il',
  'https://staging.10bis.co.il',
  'https://10bis-spa-server-release-candidate-staging.10bis.co.il',
  'https://10bis-spa-server-release-candidate-dev.10bis.co.il',
  'https://10bis-spa-server-staging.tenbis.cloud',
  'https://tenbis-webapplication-staging.tenbis.cloud',
  'https://10bis-spa-server-dev.azurewebsites.net',
  'https://10bis-spa-server-dev-staging.azurewebsites.net',
  'https://10bis-spa-server-staging.azurewebsites.net',
  'https://10bis-spa-server-release-candidate-staging.azurewebsites.net',
  'https://10bis-spa-server-release-candidate-dev.azurewebsites.net',
];

const JUSTEAT_SAFE_ORIGINS = [
  'https://www.just-eat.co.il',
  'https://just-eat.co.il',
  'https://staging.just-eat.co.il',
  'https://je-il-dev.tenbis.cloud',
  'https://je-il-rc-dev.just-eat.co.il',
  'https://rc-dev.just-eat.co.il',
  'https://je-il-rc-staging.just-eat.co.il',
  'https://rc-staging.just-eat.co.il',
  'https://qa.just-eat.co.il',
  'https://je-il-test.tenbis.cloud',
];

export const POST_MESSAGE_TRUSTED_ORIGINS = [
  'https://redirect.telepay.co.il',
  ...TENBIS_SAFE_ORIGINS,
  ...JUSTEAT_SAFE_ORIGINS,
];
